module.exports = __webpack_public_path__ + "img/main-03-03-pg.1693e2e8.png";